import main from './main/types'
import i18n from './i18n/types'
import ui from './ui/types'
import user from './user/types'
import planning from './planning/types'
import crops from './crops/types'
import products from './products/types'
import shoppingcart from './shoppingcart/types'

export default {
  main,
  i18n,
  ui,
  user,
  planning,
  crops,
  products,
  shoppingcart
}
